/**
 * Transforma um número para o formato Brasileiro (`1.000,00`).
 *
 * @param num Número no formato Americano (`1,000.00`)
 * @returns Número no formato Brasileiro (`1.000,00`)
 */
export const formatFloatToBR = (num: string) => {
  return num?.replace(/\,/g, '').replace('.', ',').replace(/\s/g, '');
};

/**
 * Transforma um número para o formato Americano (`1,000.00`).
 *
 * @param num Número no formato Brasileiro (`1.000,00`)
 * @returns Número no formato Americano (`1,000.00`)
 */
export const formatFloatToUS = (num: string) => {
  return num?.replace(/\./g, '').replace(',', '.').replace(/\s/g, '');
};
